module.exports = __webpack_public_path__ + "img/bootcamp.0cba424f.jpg";